import { render, staticRenderFns } from "./WowCase.vue?vue&type=template&id=a52d0758&scoped=true&"
import script from "./WowCase.vue?vue&type=script&lang=js&"
export * from "./WowCase.vue?vue&type=script&lang=js&"
import style0 from "./WowCase.vue?vue&type=style&index=0&id=a52d0758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52d0758",
  null
  
)

export default component.exports